<template>
    <div>
        <div class="top-site primary" v-if="!site" style="height: 142px">
        </div>
        <div class="top-site primary" v-if="site">
            <c-site-title-row
                :context = "site"
                @customer = "onCustomer"
            />

            <c-site-contact-row
                :contacts    = "contacts"
                :contracts   = "site.liftmanagement"
                :liftmanager = "site.customer.responsibles"
                class        = "mt-3"
            />
        </div>
    </div>

</template>

<script>
import CSiteTitleRow   from "@/modules/msd/unit/components/top/CSiteTitleRow";
import CSiteContactRow from "@/modules/msd/unit/components/top/CSiteContactRow";

export default {
    name: "CSiteDataRow",

    components: {
        CSiteContactRow,
        CSiteTitleRow,
    },

    props: {
        sites: {

        }
    },

    data: () => ({
        site: null,
        contacts: null,
    }),

    mounted () {
        this.load ();
    },

    watch: {
        context () {
            this.load();
        }
    },

    computed: {
        context () {
            return this.$store.getters.context.site;
        },
    },

    methods: {
        onCustomer () {
            this.load();
        },

        load() {
            if (!this.sites || this.sites.length === 0) {
                return;
            }

            let siteId = this.sites[0].id;
            if (this.context) {
                siteId = this.context;
            }

            if (!siteId) {
                return;
            }

            this.$store.dispatch('findSiteById', siteId).then(() => {
                this.site = this.$store.getters.site;
                this.contacts = this.site.contacts;

                const maintenance = this.contacts.maintenance;
                maintenance.sort ((l,r) => {
                    if (l.roles && r.roles) {
                        const lIsTop = l.roles.find(r => r.id === 3);
                        const rIsTop = r.roles.find(r => r.id === 3);

                        if (lIsTop && !rIsTop) {
                            return -1;
                        } else if (!lIsTop && rIsTop) {
                            return 1;
                        }
                    }

                    return l.name.localeCompare(r.name);
                });

                const customer = this.contacts.customer;
                customer.sort ((l,r) => {
                    if (l.roles && r.roles) {
                        const lIsTop = l.roles.find(r => r.id === 109 || r.id === 1);
                        const rIsTop = r.roles.find(r => r.id === 109 || r.id === 1);

                        if (lIsTop && !rIsTop) {
                            return -1;
                        } else if (!lIsTop && rIsTop) {
                            return 1;
                        }
                    }

                    return l.name.localeCompare(r.name);
                });

                this.contacts.maintenance = maintenance;
                this.contacts.customer    = customer;
            })
        },
    },
}
</script>

<style scoped>

.top-site {
    color: white;
    padding: 10px;
    width: calc(100% - 75px);
    min-height: 100px;
    margin-left: 75px;
}

</style>